import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useMyContext } from '../context/MyContext';
import { useAuth } from './Auth';

// B2C page imports
import LoginPage from '../Auth/login';
import SignUpPage from '../Auth/singup';
import DashBoard from '../B2C/pages/dashborad/Dashboard';
import ReverseShipment from '../B2C/pages/shipment/reverse/reverseShipment';
import ForwordShipment from '../B2C/pages/shipment/forword/forwordShipment';
import PickupRequest from '../B2C/pages/shipment/pickuprequest/pickupRequuest';
import ShipmentTracking from '../B2C/pages/shipment/tracking/shipmentTracking';
import AddWarehouse from '../B2C/pages/warehouse/addwarehouse/addWarehouse';
import AllWarehouses from '../B2C/pages/warehouse/allWarehouse/allwarehouse';
import NDRDashboard from '../B2C/pages/disputes/NDR/ndr';
import RTODashboard from '../B2C/pages/disputes/RTO/rto';
import WeightDisputeDashboard from '../B2C/pages/disputes/weightdisputes/weightDisputes';
import PageRemittances from '../B2C/pages/payments/remmitance/Remmitance';
import PageInvoices from '../B2C/pages/payments/invoice/Invoice';
import WalletRecharge from '../B2C/pages/payments/walletReachrge/Walletrecharge';
import PaymentHistory from '../B2C/pages/payments/payment history/Paymenthistory';
import ShippingCharges from '../B2C/pages/payments/shippingCharges/ShippingCharges';
import TopupHistory from '../B2C/pages/payments/topuphistory/topupHistory';
import LostDamageClaims from '../B2C/pages/risk/LostandDamages';
import ReportsDropdown from '../B2C/pages/reports/Reports';
import RateCalculator from '../B2C/pages/settings/rateCalculator/RateCalculator';
import KYCPending from '../Admin/Customers/kycPending';
import AllShipmemt from '../B2C/pages/shipment/AllShipment/AllShipment';
import Protectedroute from './Protectedroute';
import UpadteKycDashboard from '../B2C/pages/updateKYC/updateKYC';
import PincodeService from '../B2C/pages/settings/servicablePincodes/pincodes';
import RateCard from '../B2C/pages/settings/rateCard/rateCard';
import UploadPincodeComponent from '../Admin/Settings/uploadPincode/uploadPincode';
import SetRate from '../Admin/Settings/setRate/setRate';
import AddCustomer from '../Admin/Customers/addCustomer';
import ProfilePage from '../B2C/pages/profile/profilePage';
import ViewAllCustomer from '../Admin/Customers/ViewAllCustomer';
import Support from '../B2C/pages/Help/help';
import Services from '../B2C/pages/Services/Services';
import PaymentSuccess from '../B2C/pages/payments/paymnetSucess/paymentSuccess';
import UploadWeight from '../Admin/Disputes/weightUpload/weightUpload';
import AllWeightDisputes from '../Admin/Disputes/AllDisputes/allDisputes';
import ForgotPassword from '../B2C/pages/Password/forgotPassword/forgotPassword';
import OtpverifyPassword from '../B2C/pages/Password/otpVerify.js/otpVerify';
import AllBankReq from '../Admin/Customers/allBankRequest';
// import BulkUpload from '../B2C/pages/shipment/BulkUpload/bulkUpload';
import ShopifyIntegration from '../B2C/pages/Intregration/Sopify/SDashboard';
// import ShopifyIntegration from '../B2C/pages/Intregration/Sopify/sopify';
import WooConnectPage from '../B2C/pages/Intregration/wooCom/wooCom';

import AllEmployee from '../Admin/Employees/AllEmployee/allEmployee';
import AddEmployee from '../Admin/Employees/AddEmployee/addEmployee';
// import SetOffer from '../Admin/offers/setOffer'
import OfferSessionPanel from '../Admin/offers/setOffer';
import AllOffers from '../Admin/offers/viewAllOffer';
import RemmitanceList from '../B2C/pages/payments/remmitance/RemmitanceList';
import Integration from '../B2C/pages/Intregration/allChanelIntregration/allChanelIntregration';
import CommunicationConfig from '../B2C/pages/Intregration/whatappCommunication/communication ';
import WhatsAppRatesManager from '../B2C/pages/Intregration/Admin/setCommunication/setCommunication';
import ShippingLabelCustomizer from '../B2C/pages/setting/label/labelCustomized';
import PickupXpressAPIDocs from '../B2C/pages/Intregration/apidoc/apiDoc';
import CallbackPageWoocom from '../B2C/pages/Intregration/wooCom/callbackPagewoocome'
import ShopifySucuessCallback from '../B2C/pages/Intregration/Sopify/callbackPageShopify'
// B2B Page imports
import B2BDashBoard from '../B2B/pages/B2BDashboard/b2bDashboard';
import B2BAddWarehouse from '../B2B/pages/B2BWarehouse/b2baddWarehouse';
import B2BViewAllWarehouse from '../B2B/pages/B2BWarehouse/b2bAllWarehouse';
import B2BPickuprequest from '../B2B/pages/pickupRequest/b2bPickuprequest'

// Shipment modules 

import B2BForwordShipment from '../B2B/pages/B2BShipment/b2bforwordShipment';
// import B2BReverseShipment from '../B2B/pages/B2BShipment/b2breverseShipment';
import B2bAllShipmentList from '../B2B/pages/B2BShipment/b2bAllShipmentList';
import B2BTrackShipment from '../B2B/pages/B2BShipment/B2BTrackShipment';
import B2BRateCard from '../B2B/pages/Preship/RateCard/rateCard';
import B2BSetRate from '../B2B/pages/Admin/SetRate/rateSet';
import B2bRateCalculator from '../B2B/pages/Preship/RateCalculator/b2bRateCalculator';
import B2bUserProfileEdit from '../B2B/pages/profile/b2bProfile';
import B2bTopupHistory from '../B2B/pages/topuphistory/b2btopuphistory';
import B2bWalletRecharge from '../B2B/pages/walletRecharge/b2bWalletRecharge';
import B2bShippingCharges from '../B2B/pages/shippingCharges/B2bShippingCharges';
import B2bSupport from '../B2B/pages/B2BHelp/b2bhelp';
import B2bReports from '../B2B/pages/B2BReport/Report';


// Import the B2B Protected Route component
import B2BProtectedRoute from './B2bRedirectedRoutes';

export default function Redirectroute() {
  const { isAuthenticated, loading } = useAuth();
  const profile_flag = localStorage.getItem("profile_flag");
  const role = localStorage.getItem("role");
  const location = useLocation();
  const { isB2BMode } = useMyContext();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Check if the current path is a B2B path
  const isB2BPath = location.pathname.startsWith('/b2b');

  // Determine the appropriate fallback route based on mode
  const getDefaultRedirect = () => {
    if (isB2BMode) {
      return "/b2b/dashboard";
    } else {
      return "/dashboard";
    }
  };

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/CallbackPageWoocom" element={<CallbackPageWoocom />} />
      <Route path="/ShopifySucuessCallback" element={<ShopifySucuessCallback />} />
      {!isAuthenticated ? (
        <>
          <Route path="/register" element={<SignUpPage />} />
          <Route path="/" element={<LoginPage />} />
          <Route path="/forget-password" element={<ForgotPassword />} />
          <Route path="/Otp-verify" element={<OtpverifyPassword />} />
          <Route path="*" element={<Navigate to="/" state={{ from: location }} />} />
        </>
      ) : (
        <>
          {(profile_flag === "0" && role !== "admin") ? (
            <Route element={<Protectedroute />}>
              <Route path="/dashboard" element={<DashBoard />} />
              <Route path="/updateKYC" element={<UpadteKycDashboard />} />

              {/* Wrap B2B routes in B2BProtectedRoute */}
              <Route element={<B2BProtectedRoute />}>
                <Route path="/b2b/dashboard" element={<B2BDashBoard />} />
              </Route>

              {/* Default route redirect based on current mode */}
              <Route path="*" element={<Navigate to={getDefaultRedirect()} />} />
            </Route>
          ) : (
            <>
              {(profile_flag === "1" && role === "retailer") ? (
                <Route element={<Protectedroute />}>
                  {/* B2C Routes */}
                  <Route path="/updateKYC" element={<UpadteKycDashboard />} />
                  <Route path="/dashboard" element={<DashBoard />} />
                  <Route path="/shipments/forward" element={<ForwordShipment />} />
                  {/* <Route path="/shipments/bulkUpload" element={<BulkUpload />} /> */}
                  <Route path="/shipments/reverse" element={<ReverseShipment />} />
                  <Route path="/shipments/pickuprequest" element={<PickupRequest />} />
                  <Route path="/shipments/tracking" element={<ShipmentTracking />} />
                  <Route path="/shipments/all" element={<AllShipmemt />} />
                  <Route path="/warehouse/add" element={<AddWarehouse />} />
                  <Route path="/warehouse/all" element={<AllWarehouses />} />
                  <Route path="/disputes/NDR" element={<NDRDashboard />} />
                  {/* <Route path="/disputes/RTO" element={<RTODashboard />} /> */}
                  <Route path="/disputes/weight" element={<WeightDisputeDashboard />} />
                  <Route path="/payments/remmitance" element={<PageRemittances />} />
                  <Route path="/payments/invoice" element={<PageInvoices />} />
                  <Route path="/payments/walletbalance" element={<WalletRecharge />} />
                  <Route path="/payments/history" element={<PaymentHistory />} />
                  <Route path="/payments/shippingCharges" element={<ShippingCharges />} />
                  <Route path="/payments/topupHistory" element={<TopupHistory />} />
                  <Route path="/risk/claims/lost&damages" element={<LostDamageClaims />} />
                  <Route path="/reports" element={<ReportsDropdown />} />
                  <Route path="/settings/rateCalculator" element={<RateCalculator />} />
                  <Route path="/settings/pincode" element={<PincodeService />} />
                  <Route path="/settings/rateCard" element={<RateCard />} />
                  {/* <Route path="/settings/addPincode" element={<UploadPincodeComponent />} /> */}
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/help" element={<Support />} />
                  <Route path="/paymentSuccess" element={<PaymentSuccess />} />
                  <Route path="integration/sopify" element={<ShopifyIntegration />} />
                  <Route path="integration/api_doc_px" element={<PickupXpressAPIDocs />} />
                  <Route path="integration/woocom" element={<WooConnectPage />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/labelCustomized" element={<ShippingLabelCustomizer />} />
                  <Route path="/intregration" element={<Integration />} />
                  <Route path="/intregration/communication" element={<CommunicationConfig />} />

                  {/* B2B routes wrapped in B2BProtectedRoute */}
                  <Route element={<B2BProtectedRoute />}>
                    <Route path="/b2b/dashboard" element={<B2BDashBoard />} />
                    <Route path="/b2b/shipments/forward" element={<B2BForwordShipment />} />
                    {/* <Route path="/b2b/shipments/reverse" element={<B2BReverseShipment />} /> */}
                    <Route path="/b2b/shipments/list" element={<B2bAllShipmentList />} />
                    <Route path="/b2b/shipment/pickuprequest" element={<B2BPickuprequest />} />
                    <Route path="/b2b/warehouse/add" element={<B2BAddWarehouse />} />
                    <Route path="/b2b/warehouse/all" element={<B2BViewAllWarehouse />} />
                    <Route path="/b2b/shipment/track" element={<B2BTrackShipment />} />
                    <Route path="/b2b/preship/rateCard" element={<B2BRateCard />} />
                    <Route path="/b2b/preship/PriceEstimator" element={<B2bRateCalculator />} />
                    <Route path="/b2b/payments/topuphistory" element={<B2bTopupHistory />} />
                    <Route path="/b2b/payments/wallet_recharge" element={<B2bWalletRecharge />} />
                    <Route path="/b2b/payments/shippingCharges" element={< B2bShippingCharges />} />
                    <Route path="/b2b/profile" element={<B2bUserProfileEdit />} />
                    <Route path="/b2b/help" element={<B2bSupport />} />
                      <Route path="integration/api_doc_px" element={<PickupXpressAPIDocs />} />
                      <Route path="/b2b/reports" element={<B2bReports/>} />
                    {/* Redirect B2B wildcard routes to B2B dashboard */}
                    <Route path="/b2b/*" element={<Navigate to="/b2b/dashboard" />} />
                  </Route>

                  {/* Default route redirect based on current mode */}
                  <Route path="*" element={<Navigate to={getDefaultRedirect()} />} />
                </Route>
              ) : (
                <>
                  {(profile_flag === "1" && role === "admin") ? (
                    <Route element={<Protectedroute />}>
                      {/* Admin B2C Routes */}
                      <Route path="/updateKYC" element={<UpadteKycDashboard />} />
                      <Route path="/dashboard" element={<DashBoard />} />
                      <Route path="/shipments/forward" element={<ForwordShipment />} />
                      <Route path="/shipments/reverse" element={<ReverseShipment />} />
                      {/* <Route path="/shipments/bulkUpload" element={<BulkUpload />} /> */}
                      <Route path="/shipments/pickuprequest" element={<PickupRequest />} />
                      <Route path="/shipments/tracking" element={<ShipmentTracking />} />
                      <Route path="/shipments/all" element={<AllShipmemt />} />
                      <Route path="/intregration/sopify" element={<ShopifyIntegration />} />
                      <Route path="integration/woocom" element={<WooConnectPage />} />
                      <Route path="/warehouse/add" element={<AddWarehouse />} />
                      <Route path="/warehouse/all" element={<AllWarehouses />} />
                      <Route path="/disputes/NDR" element={<NDRDashboard />} />
                      <Route path="/disputes/RTO" element={<RTODashboard />} />
                      <Route path="/disputes/weight" element={<WeightDisputeDashboard />} />
                      <Route path="/disputes/wightUpload" element={<UploadWeight />} />
                      <Route path="/disputes/allWeightDisputes" element={<AllWeightDisputes />} />
                      <Route path="/payments/remmitance" element={<PageRemittances />} />
                      <Route path="/payments/invoice" element={<PageInvoices />} />
                      <Route path="/payments/walletbalance" element={<WalletRecharge />} />
                      <Route path="/payments/history" element={<PaymentHistory />} />
                      <Route path="/payments/shippingCharges" element={<ShippingCharges />} />
                      <Route path="/payments/topupHistory" element={<TopupHistory />} />
                      <Route path="/risk/claims/lost&damages" element={<LostDamageClaims />} />
                      <Route path="/reports" element={<ReportsDropdown />} />
                      <Route path="/settings/rateCalculator" element={<RateCalculator />} />
                      <Route path="/settings/pincode" element={<PincodeService />} />
                      <Route path="/settings/rateCard" element={<RateCard />} />
                      <Route path="/settings/addPincode" element={<UploadPincodeComponent />} />
                      <Route path="/settings/setRate" element={<SetRate />} />
                      <Route path="/customers/viewCustomer" element={<ViewAllCustomer />} />
                      <Route path="/customers/addCustomer" element={<AddCustomer />} />
                      <Route path="/customers/kycPending" element={<KYCPending />} />
                      <Route path="/profile" element={<ProfilePage />} />
                      <Route path="/help" element={<Support />} />
                      <Route path="/paymentSuccess" element={<PaymentSuccess />} />
                      <Route path="/services" element={<Services />} />
                      <Route path="/allReqForBankdoc" element={<AllBankReq />} />
                      <Route path="/allEmployee" element={<AllEmployee />} />
                      <Route path="/addEmployee" element={<AddEmployee />} />
                      <Route path="/offer/setoffer" element={<OfferSessionPanel />} />
                      <Route path="/offer/viewAllOffers" element={<AllOffers />} />
                      <Route path="/payments/remmitanceList" element={<RemmitanceList />} />
                      <Route path="/intregration" element={<WhatsAppRatesManager />} />
                      <Route path="integration/api_doc_px" element={<PickupXpressAPIDocs />} />


                      {/* B2B routes wrapped in B2BProtectedRoute */}
                      // admin B2b routes


                      <Route element={<B2BProtectedRoute />}>
                        <Route path="/b2b/dashboard" element={<B2BDashBoard />} />
                        <Route path="/b2b/shipments/forward" element={<B2BForwordShipment />} />
                        {/* <Route path="/b2b/shipments/reverse" element={<B2BReverseShipment />} /> */}
                        <Route path="/b2b/shipment/pickuprequest" element={<B2BPickuprequest />} />
                        <Route path="/b2b/shipments/list" element={<B2bAllShipmentList />} />
                        <Route path="/b2b/warehouse/add" element={<B2BAddWarehouse />} />
                        <Route path="/b2b/warehouse/all" element={<B2BViewAllWarehouse />} />
                        <Route path="/b2b/shipment/track" element={<B2BTrackShipment />} />
                        <Route path="/b2b/preship/setRate" element={<B2BSetRate />} />
                        <Route path="/b2b/profile" element={<B2bUserProfileEdit />} />
                        <Route path="/b2b/payments/topuphistory" element={<B2bTopupHistory />} />
                        <Route path="/b2b/payments/wallet_recharge" element={<B2bWalletRecharge />} />
                        <Route path="/b2b/payments/shippingCharges" element={< B2bShippingCharges />} />
                          <Route path="integration/api_doc_px" element={<PickupXpressAPIDocs />} />
                          <Route path="/b2b/reports" element={<B2bReports/>} />
                        <Route path="/b2b/help" element={<B2bSupport />} />
                        {/* Redirect B2B wildcard routes to B2B dashboard */}
                        <Route path="/b2b/*" element={<Navigate to="/b2b/dashboard" />} />
                      </Route>

                      {/* Default route redirect based on current mode */}
                      <Route path="*" element={<Navigate to={getDefaultRedirect()} />} />
                    </Route>
                  ) : (
                    <Route element={<Protectedroute />}>
                      <Route path="/dashboard" element={<DashBoard />} />

                      {/* B2B routes wrapped in B2BProtectedRoute */}
                      <Route element={<B2BProtectedRoute />}>
                        <Route path="/b2b/dashboard" element={<B2BDashBoard />} />

                        {/* Redirect B2B wildcard routes to B2B dashboard */}
                        <Route path="/b2b/*" element={<Navigate to="/b2b/dashboard" />} />
                      </Route>

                      {/* Default route redirect based on current mode */}
                      <Route path="*" element={<Navigate to={getDefaultRedirect()} />} />
                    </Route>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
    </Routes>
  );
}